import {makeAutoObservable} from 'mobx';
import {fromPromise, IPromiseBasedObservable} from 'mobx-utils';
import {getArticleList} from '../api/get-article-list.ts';
import {ArticleType} from '@wp-content-publisher/typings-lib/dist/src/server/types/article.ts';
import {removeArticle} from '../api/removeArticle.ts';

class ArticleListStore {

    list?: IPromiseBasedObservable<ArticleType[]>;

    constructor() {
        makeAutoObservable(this);
    }

    getListAction = () => {
        this.list = fromPromise(getArticleList());
    }

    onDelete = (id: number) => {
        fromPromise(removeArticle(id))
    }
}

const articleListStore = new ArticleListStore();
export {articleListStore};